module.exports = __webpack_public_path__ + "img/superDoctor.fc847657.png";